import { render, staticRenderFns } from "./ConfigCapacity.vue?vue&type=template&id=5a2a96ca&"
import script from "./ConfigCapacity.vue?vue&type=script&lang=js&"
export * from "./ConfigCapacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports